import {AfterViewChecked, Component, OnInit, AfterViewInit, ViewChild, ElementRef, ChangeDetectorRef, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import { StorageService } from '../../../../Services/storage.service';
import { AppConfigService } from '../../../../Services/app-config.service';
import { Title } from '@angular/platform-browser';
import {DataService} from '../../../../Services/data.service';
import {EmailModel} from '../../../../DataModels/email-model';
import {Modal} from 'bootstrap';
import {SendEmailModalComponent} from '../../../common/send-email-modal/send-email-modal.component';
import { DateFilterService } from '../../../../Services/dateFilter.service';
import { NotificationService } from '../../../../Services/notification.service';
import {UntypedFormBuilder} from '@angular/forms';
import { EmailService } from '../../../../Services/email.service';
import { DataExportService } from '../../../../Services/dataExport.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ResponseModel } from '../../../../DataModels/response-model';
import { EmailPassDataServiceService } from '../../../../Services/email-pass-data-service.service';
import {DatePipe} from '@angular/common';
import {CustomArrayFilterPipe} from '../../../common/custom-array-filter.pipe';
import {ReportPrintService} from '../../../../Services/report-print.service';

@Component({
  selector: 'app-balance-sheet',
  templateUrl: './balance-sheet.component.html',
  styleUrls: ['./balance-sheet.component.css'],
  standalone: false
})
export class BalanceSheetComponent implements OnInit, AfterViewInit, AfterViewChecked {
  @ViewChild('EmailContent', { static: false }) EmailContent: ElementRef;
  @ViewChild('ExcelExport', { static: false }) ExcelExport: ElementRef;
  // Reference the embedded Send Email modal component's host element (directive-driven)
  @ViewChild(SendEmailModalComponent, {read: ElementRef}) private emailModalHost: ElementRef;
  // Email modal binding object
  emailObject: EmailModel = new EmailModel();
  private rptName: string;
  loadingReport = false;
  sub;
  public vm: any = {
    toDateSelect: [],
    fromDateSelect: [],
    DataFormat: 'MM/DD/YYYY',
    dateError: false,
    report: [],
    request: {
      toDate: null,
      fromDate: null,
      fromDatePrior: null,
      location_group_id: false,
      columns: 'year',
      company_id: null,
      location_id: null,
      rf_id_1: null,
      rf_id_2: null,
      rf_id_3: null,
      rf_id_4: null,
      rf_id_5: null,
    },
    showSpecificDates: false,
    buttonsDisabled: false,
    d: {
      date: '',
      name: '',
    },
    columns: false,
    company: [],
    locationGroup: [],
    location: [],
    currency: [],
    location_group: [],
    rfType: [],
    rf1: [],
    rf2: [],
    rf3: [],
    rf4: [],
    rf5: [],
    filtered: false,
    showFilters: false,
    toDateError: false,
    totalDebits: 0,
    totalCredits: 0,
    liabEquityCurrent: 0,
    liabEquityPrior: 0,
    totalCurrentAssets: 0,
    totalPriorAssets: 0,
    totalCurrentLiabilities: 0,
    totalPriorLiabilities: 0,
    companyData: null,
    locationData: null,
    calculatedTime: new Date(),
    priorToDate: 0,
    ToEmailError: null,
    showEmail: true,
    ToEmail: null,
    emailed: null,
    email: {
      toemail: null,
      fromemail: this.appConfigService.SysEmailAddress,
      PdfHtml: null,
      Subject: null,
    },
    Preferences: null,
    permissions: null,
    exportToExcel: true,

  };
  // Standard report header button configuration
  buttonConfig: any = {
    reportFormat: false,
    print: false,
    printReport: true,
    email: true,
    update: true,
    exportExcel: true,
    close: true,
  };

  constructor(
    public localStorage: StorageService,
    public tableDataService: DataService,
    private titleService: Title,
    public appConfigService: AppConfigService,
    public dateFilter: DateFilterService,
    public notification: NotificationService,
    public aEmail: EmailService,
    private fb: UntypedFormBuilder,
    public excelExporter: DataExportService,
    public route: ActivatedRoute,
    public router: Router,
    private emailData: EmailPassDataServiceService,
    public datePipe: DatePipe,
    private cdr: ChangeDetectorRef,
    private reportPrint: ReportPrintService,
    private destroyRef: DestroyRef,
  ) {
    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions'));
    this.vm.email.toemail = this.localStorage.StorageGet('ToEmail', '');
  }

  ngOnInit() {
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      let hasUrlDates = false;
      if (params.toDate !== undefined) {
        this.vm.request.toDate = params.toDate;
        this.vm.showSpecificDates = true;
        hasUrlDates = true;
      }
      if (params.fromDate !== undefined) {
        this.vm.request.fromDate = params.fromDate;
        this.vm.showSpecificDates = true;
        hasUrlDates = true;
      }
      if (!this.vm.request.toDate && !this.vm.request.fromDate) {
        this.newDateFilter(new Date(), new Date());
        this.primeDefaultDateRange();
      }

      this.newDateFilter(this.vm.request.toDate, this.vm.request.fromDate);

      if (hasUrlDates && this.vm.request.toDate) {
        this.BalanceSheetUpdate();
      }
    });
    this.FilterOptionsInit();
    this.rptName = $localize`:Balance Sheet Report @@balanceSheetReport: Balance Sheet Report`;

  }

  private primeDefaultDateRange() {
    const range = this.dateFilter.GetDefaultDateRange('currentMonth', this.vm.fromDateSelect, this.vm.toDateSelect);
    this.vm.request.toDate = range.toDate;
    this.vm.request.fromDate = range.fromDate;
  }

  ngAfterViewInit() {
    this.titleService.setTitle(this.rptName);
    // console.log('Time Out --> ' + this.timeOut);
  }

  ngAfterViewChecked() {
    // stuff
  }

  newDateFilter(toDate, fromDate) {
    // console.log('todate: ' + toDate);
    // console.log('fromdate: ' + fromDate);
    const ret = this.dateFilter.DateFilterInit(toDate, fromDate);
    this.vm.toDateSelect = ret.toDateSelect;
    this.vm.fromDateSelect = ret.fromDateSelect;
    // console.log('fromdate:' + JSON.stringify(this.vm.fromDateSelect));
  }

  FilterOptionsInit() {
    this.tableDataService
      .getData('company?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.company = result.Data;
      });
    this.tableDataService
      .getData('currency?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.currency = result.Data;
      });
    this.tableDataService
      .getData('location?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.location = result.Data;
      });
    this.tableDataService
      .getData('location_group?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.location_group = result.Data;
      });
    this.tableDataService
      .getData('reporting_field_type?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.rfType = result.Data;
      });
    this.tableDataService
      .getData('reporting_field', '?state=active&type_id=rf1&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.rf1 = result.Data;
      });
    this.tableDataService
      .getData('reporting_field', '?state=active&type_id=rf2&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.rf2 = result.Data;
      });
    this.tableDataService
      .getData('reporting_field', '?state=active&type_id=rf3&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.rf3 = result.Data;
      });
    this.tableDataService
      .getData('reporting_field', '?state=active&type_id=rf4&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.rf4 = result.Data;
      });
    this.tableDataService
      .getData('reporting_field', '?state=active&type_id=rf5&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.rf5 = result.Data;
      });
  }

  makeNumber(value, sub) {
    if (typeof value !== 'undefined') {
      if (typeof value[sub] !== 'undefined') {
        return value[sub];
      }
    }
    return 0;
  }

  // Helper: sum an array of accounts for the specified numeric field
  private sumAccounts(accounts: any[], field: 'current_period' | 'prior_period'): number {
    try {
      if (!Array.isArray(accounts)) {
        return 0;
      }
      return accounts.reduce((acc, a) => acc + Number(a?.[field] || 0), 0);
    } catch {
      return 0;
    }
  }

  // Expose helpers to template to ensure subtotal values are visible even when API omits them
  getSubCurrent(sub: any): number {
    if (!sub) {
      return 0;
    }
    const val = sub.current_period;
    return (val !== undefined && val !== null) ? Number(val) : this.sumAccounts(sub.accounts || [], 'current_period');
  }

  getSubPrior(sub: any): number {
    if (!sub) {
      return 0;
    }
    const val = sub.prior_period;
    return (val !== undefined && val !== null) ? Number(val) : this.sumAccounts(sub.accounts || [], 'prior_period');
  }

  // ---- Helpers for Liabilities subtotal placement and totals ----
  // Compute a section's current total robustly by walking parents/subtotals/accounts when section-level totals are missing
  private sectionCurrentTotal(section: any): number {
    try {
      // Prefer explicit section total when supplied by API
      const explicit = section?.totalCurrentPeriod;
      if (explicit !== undefined && explicit !== null && !Number.isNaN(Number(explicit))) {
        return Number(explicit);
      }
      const parents: any[] = Array.isArray(section?.parents) ? section.parents : [];
      let sum = 0;
      for (const p of parents) {
        if (p?.current_period !== undefined && p?.current_period !== null) {
          sum += Number(p.current_period || 0);
        } else {
          const subs: any[] = Array.isArray(p?.subtotals) ? p.subtotals : [];
          for (const s of subs) {
            sum += this.getSubCurrent(s);
          }
        }
      }
      return sum;
    } catch {
      return 0;
    }
  }

  private sectionPriorTotal(section: any): number {
    try {
      // Prefer explicit section total when supplied by API
      const explicit = section?.totalPriorPeriod;
      if (explicit !== undefined && explicit !== null && !Number.isNaN(Number(explicit))) {
        return Number(explicit);
      }
      const parents: any[] = Array.isArray(section?.parents) ? section.parents : [];
      let sum = 0;
      for (const p of parents) {
        if (p?.prior_period !== undefined && p?.prior_period !== null) {
          sum += Number(p.prior_period || 0);
        } else {
          const subs: any[] = Array.isArray(p?.subtotals) ? p.subtotals : [];
          for (const s of subs) {
            sum += this.getSubPrior(s);
          }
        }
      }
      return sum;
    } catch {
      return 0;
    }
  }

  isLiabilityParent(title: any): boolean {
    return String(title || '').toLowerCase().includes('liabil');
  }

  // Compute totals for liabilities-only within the Liabilities & Equity section
  liabilitiesCurrentTotal(totals: any): number {
    try {
      const parents = Array.isArray(totals?.parents) ? totals.parents : [];
      let sum = 0;
      for (const p of parents) {
        if (this.isLiabilityParent(p?.title)) {
          if (p?.current_period !== undefined && p?.current_period !== null) {
            sum += Number(p.current_period || 0);
          } else {
            // Sum from subtotals if parent current not provided
            const subs: any[] = Array.isArray(p?.subtotals) ? p.subtotals : [];
            for (const s of subs) {
              sum += this.getSubCurrent(s);
            }
          }
        }
      }
      return sum;
    } catch {
      return 0;
    }
  }

  liabilitiesPriorTotal(totals: any): number {
    try {
      const parents = Array.isArray(totals?.parents) ? totals.parents : [];
      let sum = 0;
      for (const p of parents) {
        if (this.isLiabilityParent(p?.title)) {
          if (p?.prior_period !== undefined && p?.prior_period !== null) {
            sum += Number(p.prior_period || 0);
          } else {
            const subs: any[] = Array.isArray(p?.subtotals) ? p.subtotals : [];
            for (const s of subs) {
              sum += this.getSubPrior(s);
            }
          }
        }
      }
      return sum;
    } catch {
      return 0;
    }
  }

  // Sum selected parents for a single company aggregation object (Company mode)
  // parentIds are the canonical parent_id values to include (e.g., ['Liabilities', 'Equity']).
  companyParentsTotal(companyAgg: any, parentIds: string[]): number {
    try {
      const include = new Set((parentIds || []).map(v => String(v)));
      const parents: any[] = Array.isArray(companyAgg?.parents) ? companyAgg.parents : [];
      let sum = 0;
      for (const p of parents) {
        const pid = String(p?.parent_id ?? p?.title ?? '');
        if (include.has(pid)) {
          const hasAmt = p?.amount !== undefined && p?.amount !== null && !Number.isNaN(Number(p.amount));
          if (hasAmt) {
            sum += Number(p.amount);
          } else {
            // Fallback: sum matching subtotals if parent amount not provided
            const subs: any[] = Array.isArray(companyAgg?.subtotals) ? companyAgg.subtotals : [];
            for (const s of subs) {
              if (String(s?.parent_id) === pid) {
                sum += Number(s?.amount || 0);
              }
            }
          }
        }
      }
      return sum;
    } catch {
      return 0;
    }
  }

  // New helper: always compute from subtotals only, never using parents array amounts
  companyParentsTotalFromSubtotals(companyAgg: any, parentIds: string[]): number {
    try {
      const include = new Set((parentIds || []).map(v => String(v)));
      const subs: any[] = Array.isArray(companyAgg?.subtotals) ? companyAgg.subtotals : [];
      let sum = 0;
      for (const s of subs) {
        const pid = String(s?.parent_id ?? '');
        if (include.has(pid)) {
          sum += Number(s?.amount || 0);
        }
      }
      return sum;
    } catch {
      return 0;
    }
  }

  // New helper per new API shape requirement: totalize ONLY from detail accounts amounts,
  // ignoring any parent or subtotal precomputed amounts.
  companyParentsTotalFromAccounts(companyAgg: any, parentIds: string[]): number {
    try {
      const include = new Set((parentIds || []).map(v => String(v)));
      const accounts: any[] = Array.isArray(companyAgg?.accounts) ? companyAgg.accounts : [];
      let sum = 0;
      for (const a of accounts) {
        const pid = String(a?.parent_id ?? '');
        if (include.has(pid)) {
          sum += Number(a?.amount || 0);
        }
      }
      return sum;
    } catch {
      return 0;
    }
  }

  // Variant: match parent identifiers by substring (case-insensitive), e.g., 'assets' matches 'current-assets', 'fixed-assets'
  companyParentsTotalFromAccountsByContains(companyAgg: any, parentIdContains: string[]): number {
    try {
      const needles = (parentIdContains || []).map(s => String(s).toLowerCase());
      const accounts: any[] = Array.isArray(companyAgg?.accounts) ? companyAgg.accounts : [];
      let sum = 0;
      for (const a of accounts) {
        const pid = String(a?.parent_id ?? '').toLowerCase();
        if (needles.some(n => pid.includes(n))) {
          sum += Number(a?.amount || 0);
        }
      }
      return sum;
    } catch {
      return 0;
    }
  }

  // Build query params for Transaction Detail link similar to Income Statement
  getTxnQueryParams(a: any, isPrior: boolean = false): any {
    const req = this.vm?.request || {};

    // Helper to safely parse a date string
    const parseDate = (val: any): Date | null => {
      if (!val) {
        return null;
      }
      const d = new Date(val);
      return isNaN(d.getTime()) ? null : d;
    };
    const fmt = (d: Date | null) => d ? this.datePipe.transform(d, 'MM/dd/yyyy') : null;

    let fromDate = req.fromDate || null;
    let toDate = req.toDate || null;

    if (isPrior) {
      const to = parseDate(req.toDate);
      if (String(req.columns) === 'year') {
        if (to) {
          // Prior year same day
          const priorYear = new Date(to.getFullYear() - 1, to.getMonth(), to.getDate());
          toDate = fmt(priorYear);
        }
        // Shift fromDate back a year if present, else default to Jan 1 of that prior year
        const from = parseDate(req.fromDate);
        if (from) {
          const priorFrom = new Date(from.getFullYear() - 1, from.getMonth(), from.getDate());
          fromDate = fmt(priorFrom);
        } else if (to) {
          const jan1 = new Date(to.getFullYear() - 1, 0, 1);
          fromDate = fmt(jan1);
        }
      } else if (String(req.columns) === 'month') {
        // Use the last day of the prior month (already computed on vm.priorToDateMonth)
        const priorMonthEndTs = this.vm?.priorToDateMonth;
        const priorMonthEnd = priorMonthEndTs ? new Date(priorMonthEndTs) : (to ? new Date(to.getFullYear(), to.getMonth(), 0) : null);
        toDate = fmt(priorMonthEnd);
        if (priorMonthEnd) {
          // First day of prior month
          const firstDay = new Date(priorMonthEnd.getFullYear(), priorMonthEnd.getMonth(), 1);
          fromDate = fmt(firstDay);
        }
      } else {
        // Fallback: default to prior year if no specific columns type
        const to = parseDate(req.toDate);
        if (to) {
          const priorYear = new Date(to.getFullYear() - 1, to.getMonth(), to.getDate());
          toDate = fmt(priorYear);
          const jan1 = new Date(priorYear.getFullYear(), 0, 1);
          fromDate = fmt(jan1);
        }
      }
    }

    return {
      accountId: a?.account_id,
      companyId: req.company_id,
      currencyId: req.currency_id,
      inventoryItemId: req.item_id,
      locationId: req.location_id,
      locationGroupId: req.location_group_id,
      fromDate: fromDate,
      toDate: toDate,
      entityId: req.entity_id,
      entityTypeId: req.entity_type_id,
      entityState: req.entity_state,
      entityCity: req.entity_city,
      rfId1: req.rf_id_1,
      rfId2: req.rf_id_2,
      rfId3: req.rf_id_3,
      rfId4: req.rf_id_4,
      rfId5: req.rf_id_5,
    };
  }

  calcTotals() {
    this.vm.totalDebits = this.vm.totalCredits = this.vm.liabEquityCurrent = this.vm.liabEquityPrior = 0;
    // Initialize liabilities-only totals
    this.vm.totalCurrentLiabilities = 0;
    this.vm.totalPriorLiabilities = 0;

    for (const [x, value] of Object.entries(this.vm.report)) {
      const section: any = this.vm.report[x];
      const title = String(section?.title || '').toLowerCase();

      if (title.includes('asset')) {
        // Assets: prefer section totals, otherwise compute
        this.vm.totalCurrentAssets = this.sectionCurrentTotal(section);
        this.vm.totalPriorAssets = this.sectionPriorTotal(section);
        continue;
      }

      // Treat any non-Assets section as Liabilities & Equity aggregate
      this.vm.liabEquityCurrent += this.sectionCurrentTotal(section);
      this.vm.liabEquityPrior += this.sectionPriorTotal(section);

      // Compute Liabilities-only totals from the Liabilities & Equity section by summing only
      // parents whose title indicates Liabilities. This supports titles like 'Liabilities & Equity'.
      this.vm.totalCurrentLiabilities = this.liabilitiesCurrentTotal(section);
      this.vm.totalPriorLiabilities = this.liabilitiesPriorTotal(section);
    }
  }

  FilterObject(value, filterObj, except = false) {
    // return new FilterPipe().transform(value, filterObj);
    return new CustomArrayFilterPipe().transform(value, filterObj);
  }

  close() {
    this.router.navigateByUrl('/home').then();
  }

  // exportReport() {
  //   this.notification.warning('Email address required.');
  // }

  exportToExcel() {
    this.excelExporter.exportToExcel(this.ExcelExport, this.rptName + '.xlsx');
  }

  BalanceSheetUpdate() {
    this.loadingReport = true;
    this.vm.report = [];
    if (!this.vm.request.toDate) {
      this.vm.toDateError = true;
      this.notification.warning($localize`:Date is required. @@dateisrequired:Date is required.`);
      this.loadingReport = false;
      return;
    } else {
      this.vm.request.toDate = this.dateFilter.GetDateFormat(this.vm.request.toDate);
      this.vm.request.fromDate = this.dateFilter.GetDateFormat(this.vm.request.fromDate);

      // this.vm.buttonsDisabled = true;
      this.vm.toDateError = false;
      // this.localStorage.StorageSet('toDate', this.vm.request.toDate);

      const originalToDate = new Date(this.vm.request.toDate);
      const fromPrior = new Date(originalToDate.getFullYear() - 2, originalToDate.getMonth(), 1);
      this.vm.request.fromDatePrior = this.datePipe.transform(fromPrior, 'MM/dd/yyyy');
      const from = new Date(originalToDate.getFullYear() - 1, originalToDate.getMonth(), 1);
      this.vm.request.fromDate = this.datePipe.transform(from, 'MM/dd/yyyy');

      // console.log('prior col date: ' + this.vm.request.fromDatePrior);

      // console.log('fromdate: ' + this.vm.request.fromDate);



      let paramString = '';
      if (this.vm.request.fromDate) {
        paramString += '&fromDate=' + this.vm.request.fromDate;
      }
      if (this.vm.request.toDate) {
        paramString += '&toDate=' + this.vm.request.toDate;
      }
      if (this.vm.request.company_id) {
        paramString += '&company_id=' + this.vm.request.company_id;
      } else if (this.vm.Preferences.default_company_id) {
        this.vm.request.company_id = this.vm.Preferences.default_company_id;
      }
      if (this.vm.request.location_id) {
        paramString += '&location_id=' + this.vm.request.location_id;
      }
      if (this.vm.request.location_group_id) {
        paramString += '&location_group_id=' + this.vm.request.location_group_id;
      }
      if (this.vm.request.rf_id_1) {
        paramString += '&rf_id_1=' + this.vm.request.rf_id_1;
      }
      if (this.vm.request.rf_id_2) {
        paramString += '&rf_id_2=' + this.vm.request.rf_id_2;
      }
      if (this.vm.request.rf_id_3) {
        paramString += '&rf_id_3=' + this.vm.request.rf_id_3;
      }
      if (this.vm.request.rf_id_4) {
        paramString += '&rf_id_4=' + this.vm.request.rf_id_4;
      }
      if (this.vm.request.rf_id_5) {
        paramString += '&rf_id_5=' + this.vm.request.rf_id_5;
      }

      if (paramString[0] == '&') {
        paramString = paramString.substring(1);
      }

      // determine prior period flag to send api
      if (this.vm.request.columns == 'month') {
        paramString += '&priorPeriod=' + 'm';
      } else {
        paramString += '&priorPeriod=' + '';
      }
      // console.log('bs params: ' + paramString);
      this.tableDataService.getData('balance_sheet', '?' + paramString).subscribe((result: any[]) => {
        this.vm.report = result;
        // console.log('bs data: ', result);
        // Ensure the Calculated Retained Earnings placeholder row exists for Company view
        // (row label rendered as "Calculated Retained Earnings"). This does not change totals —
        // it simply guarantees the row appears when amounts are supplied via companyIndex.
        try {
          this.injectCalculatedRetainedEarningsRow();
        } catch { /* no-op */
        }
        this.calcTotals();
        this.vm.buttonsDisabled = false;
        if (this.vm.request.columns === 'company') {
          // Use the consolidation endpoint specifically for company columns
          this.vm.filtered = true;
          let cParam = '?toDate=' + this.vm.request.toDate;
          if (this.vm.request.company_id != null) {
            cParam += '&company_id=' + this.vm.request.company_id;
          }
          this.tableDataService
            .getData('BalanceSheetCompanyConsolidation', cParam)
            .subscribe((CData: any[]) => {
              // console.log('cdata: ', CData);
              const {rows, index} = this.normalizeCompanyConsolidation(Array.isArray(CData) ? CData : []);
              this.vm.companyData = rows;
              this.vm.companyIndex = index;
            });
        } else if (this.vm.request.columns === 'location') {
          this.vm.filtered = true;
          let paramStr = '?toDate=' + this.vm.request.toDate;
          if (this.vm.request.company_id != null) {
            paramStr += '&company_id=' + this.vm.request.company_id;
          }
          this.tableDataService
            .getData('BalanceSheetLocationConsolidation', paramStr)
            .subscribe((lData: any[]) => {
              this.vm.locationData = lData;
              // console.log('ldata: ', lData);

              for (const [x, value] of Object.entries(this.vm.locationData)) {
                for (const [y, value2] of Object.entries(this.vm.locationData[x].subtotals)) {
                  if (
                    typeof this.FilterObject(this.vm.location, { id: this.vm.locationData[x].location_id })[0] !==
                      'undefined' &&
                    this.FilterObject(this.vm.location, { id: this.vm.locationData[x].location_id })[0] !== null &&
                    typeof this.FilterObject(this.vm.location, { id: this.vm.locationData[x].location_id })[0].name !==
                      'undefined'
                  ) {
                    this.vm.locationData[x].name = this.FilterObject(this.vm.location, {
                      id: this.vm.locationData[x].location_id,
                    })[0].name;
                  } else if (this.vm.locationData[x].location_id === 'NULL') {
                    this.vm.locationData[x].name = 'z-blank';
                  } else {
                    this.vm.locationData[x].name = 'unknown';
                  }
                  this.vm.locationData[x].subtotals[y].amount = 0;

                  for (const [z, value3] of Object.entries(this.vm.locationData[x].accounts)) {
                    if (
                      this.vm.locationData[x].accounts[z].subtotal_id ===
                      this.vm.locationData[x].subtotals[y].subtotal_id
                    ) {
                      this.vm.locationData[x].subtotals[y].amount += this.vm.locationData[x].accounts[z].amount;
                    }
                  }
                }
                let tempNetIncome = 0;
                let tempMargin = 0;
                for (const [y, value2] of Object.entries(this.vm.locationData[x].parents)) {
                  this.vm.locationData[x].parents[y].amount = 0;
                  this.vm.locationData[x].revenueAmount = 0;

                  for (const [z, value3] of Object.entries(this.vm.locationData[x].subtotals)) {
                    if (
                      this.vm.locationData[x].subtotals[z].parent_id === this.vm.locationData[x].parents[y].parent_id
                    ) {
                      this.vm.locationData[x].parents[y].amount += this.vm.locationData[x].subtotals[z].amount;
                    }
                    if (this.vm.locationData[x].subtotals[z].parent_id === 'Assets') {
                      tempNetIncome += this.vm.locationData[x].subtotals[z].amount;
                      tempMargin += this.vm.locationData[x].subtotals[z].amount;
                      this.vm.locationData[x].revenueAmount += this.vm.locationData[x].subtotals[z].amount;
                    }
                  }
                }
                this.vm.locationData[x].subtotals.push({
                  subtotal_id: 'Assets',
                  amount: tempNetIncome,
                });
              }
            });
        }
        const d = new Date();
        this.vm.calculatedTime = d;
        const tempToDate = new Date(this.vm.request.toDate);
        // Compute prior year reference date for headers
        this.vm.priorToDate = tempToDate.setFullYear(tempToDate.getFullYear() - 1);
        // Also compute prior month reference date for month comparison headers
        // Use the LAST day of the prior month regardless of the current day selection
        const toDateObj = new Date(this.vm.request.toDate);
        // Day 0 of the current month yields the last day of the previous month
        const priorMonthEnd = new Date(toDateObj.getFullYear(), toDateObj.getMonth(), 0);
        this.vm.priorToDateMonth = priorMonthEnd.getTime();
        this.loadingReport = false;
      });
      return false;
    }
  }

  // New email flow using shared Send Email modal and directive-driven opening
  async onEmail() {
    try {
      // Build a polished HTML document for the email attachment (same as print)
      const htmlDoc = this.buildPrintHtml(true);

      const emailDocObj = {} as EmailModel;
      const emailDocumentName = 'Balance Sheet';

      emailDocObj.print_orientation = '1'; // portrait
      emailDocObj.convert_attachment_to = 'pdf';
      emailDocObj.fromEmail = '';
      emailDocObj.fromName = 'AcctXErp';
      emailDocObj.header_id = null as any;
      emailDocObj.toEmail = '';
      emailDocObj.body = 'Please see the attached ' + emailDocumentName + '.<br><br><br>'
        + 'Best regards,'
        + '<br><br>'
        + 'AcctXErp'
        + '<br><br>';
      const dateStr = this.vm?.request?.toDate ? ` ${this.vm.request.toDate}` : '';
      emailDocObj.Subject = 'AcctXErp ' + emailDocumentName + dateStr;
      emailDocObj.activity_message = emailDocumentName;

      try {
        emailDocObj.pdfHtml = htmlDoc || '';
      } catch {
        emailDocObj.pdfHtml = '';
      }

      const safeName = (emailDocumentName || 'document').replace(/\s+/g, '_');
      emailDocObj.FileName = `${safeName}${this.vm?.request?.toDate ? '_' + this.vm.request.toDate : ''}.pdf`;

      // Bind for modal
      this.emailObject = emailDocObj;

      // Flush input bindings
      this.cdr.detectChanges();

      // Locate modal element via directive
      let emailEl: HTMLElement | null = null;
      try {
        emailEl = (this.emailModalHost?.nativeElement as HTMLElement)?.querySelector?.('#sendEmailModal') || null;
      } catch {
        emailEl = null;
      }
      if (!emailEl) {
        emailEl = document.getElementById('sendEmailModal');
      }

      // If nested within any other modal with id starting with bs, move to body (robustness)
      if (emailEl && emailEl.parentElement && emailEl.closest('.modal')) {
        document.body.appendChild(emailEl);
      }

      const modal = emailEl ? Modal.getOrCreateInstance(emailEl) : null;
      modal?.show();
    } catch (e) {
      console.error('Balance Sheet prepare email failed', e);
    }
  }

  // Print the report content using a generated HTML document
  printReport() {
    try {
      const html = this.buildPrintHtml();
      this.printHtmlInIframe(html);
    } catch (e) {
      console.error('Balance Sheet print failed', e);
      this.notification.error?.('Unable to print Balance Sheet');
    }
  }

  // Build a self-contained, visually polished HTML for printing/emailing the current report
  private buildPrintHtml(forEmail: boolean = false): string {
    const content = this.reportPrint.cleanContentHtml((this.EmailContent?.nativeElement?.innerHTML || '').toString());
    const toDate = this.vm?.request?.toDate ? String(this.vm.request.toDate) : '';
    const meta: { label: string; value: string }[] = [];
    if (toDate) {
      meta.push({label: 'As of', value: toDate});
    }
    return this.reportPrint.buildHtml({title: 'Balance Sheet', contentHtml: content, meta, orientation: 'landscape'});
  }

  private printHtmlInIframe(html: string): void {
    this.reportPrint.printInIframe(html);
  }

  private normalizeCompanyConsolidation(raw: any[]): { rows: any[]; index: any } {
    const rows: any[] = [];
    const byCompany = new Map<string | number, any>();
    const accountAmount = new Map<string, number>();
    const subtotalAmount = new Map<string, number>();
    const parentTotal = new Map<string, number>();

    const data = Array.isArray(raw) ? raw : [];
    for (const r of data) {
      const company_id = r?.company_id ?? r?.id;
      const company_name = r?.company_name || r?.name || 'unknown';

      const parents: any[] = Array.isArray(r?.parents) ? r.parents : [];
      const flatAccounts: any[] = [];
      const subtotalMap = new Map<string, { subtotal_id: string; parent_id: string; amount: number }>();

      for (const p of parents) {
        const pid = String(p?.parent_id || '');
        const subs: any[] = Array.isArray(p?.subtotals) ? p.subtotals : [];
        for (const s of subs) {
          const sid = String(s?.subtotal_id || '');
          const sAmt = Number(s?.amount || 0);
          const existing = subtotalMap.get(sid) || {subtotal_id: sid, parent_id: String(s?.parent_id || pid), amount: 0};
          existing.amount += sAmt;
          existing.parent_id = String(s?.parent_id || pid);
          subtotalMap.set(sid, existing);

          const accts: any[] = Array.isArray(s?.accounts) ? s.accounts : [];
          for (const a of accts) {
            const acc = {
              account_id: a?.account_id,
              subtotal_id: sid,
              parent_id: existing.parent_id,
              amount: Number(a?.amount || 0),
            };
            flatAccounts.push(acc);
            const aKey = `${company_id}|${acc.account_id}`;
            accountAmount.set(aKey, (accountAmount.get(aKey) || 0) + acc.amount);
          }
        }
      }

      const subtotals = Array.from(subtotalMap.values());
      for (const s of subtotals) {
        const sKey = `${company_id}|${s.subtotal_id}`;
        subtotalAmount.set(sKey, (subtotalAmount.get(sKey) || 0) + Number(s.amount || 0));
        const pKey = `${company_id}|${s.parent_id}`;
        parentTotal.set(pKey, (parentTotal.get(pKey) || 0) + Number(s.amount || 0));
      }

      try {
        const reSubtotal = subtotals.find(t => {
          const id = String(t?.subtotal_id || '').toLowerCase();
          return id.includes('retained') && id.includes('earning');
        });
        if (reSubtotal) {
          const aKey = `${company_id}|re`;
          if (!accountAmount.has(aKey)) {
            accountAmount.set(aKey, Number(reSubtotal.amount || 0));
          }
        }
      } catch { /* noop */
      }

      const row = {company_id, company_name, parents, subtotals, accounts: flatAccounts};
      rows.push(row);
      byCompany.set(company_id, row);
    }

    return {rows, index: {byCompany, accountAmount, subtotalAmount, parentTotal}};
  }

  private injectCalculatedRetainedEarningsRow(): void {
    try {
      const sections: any[] = Array.isArray(this.vm?.report) ? this.vm.report : [];
      for (const section of sections) {
        const parents: any[] = Array.isArray(section?.parents) ? section.parents : [];
        for (const parent of parents) {
          const subs: any[] = Array.isArray(parent?.subtotals) ? parent.subtotals : [];
          for (const sub of subs) {
            const sid = String(sub?.subtotal_id || '').toLowerCase();
            const stitle = String(sub?.title || '').toLowerCase();
            const looksLikeRE = (sid.includes('retained') && sid.includes('earning')) || (stitle.includes('retained') && stitle.includes('earning'));
            if (!looksLikeRE) {
              continue;
            }
            if (!Array.isArray(sub.accounts)) {
              sub.accounts = [];
            }
            const hasRE = sub.accounts.some((a: any) => String(a?.account_id).toLowerCase() === 're');
            if (!hasRE) {
              sub.accounts.push({account_id: 're', account: null, number: 'RE'});
            }
          }
        }
      }
    } catch { /* noop */
    }
  }

  hasAssetsParentId(section: any): boolean {
    try {
      const parents: any[] = Array.isArray(section?.parents) ? section.parents : [];
      return parents.some(p => String(p?.parent_id || '').toLowerCase().includes('assets'));
    } catch {
      return false;
    }
  }

}
